import { React } from 'react';
import './footer.scss';

export const Footer = ({ ...props }) => {
  // Footer Links
  // ---------------------
  const footerLinks = [
    { item: 'Contact Us', path: '/sigmaxmtf/contact' },
    { item: 'Disclaimers', path: '/sigmaxmtf/disclaimers' },
    { item: 'Terms of Use', path: '/sigmaxmtf/terms-of-use' },
    {
      item: 'Privacy Policy',
      path: 'https://www.goldmansachs.com/privacy-and-cookies/index.html',
      target: '_blank',
    },
    { item: 'Sitemap', path: '/sigmaxmtf/sitemap' },
  ];

  return (
    <div className={`footer-component`}>
      <div className="footer-wrapper">
        <div className="copyright-block">
          <div>
            <p>© Copyright 2021 Goldman Sachs International Bank</p>
            <p>
              Authorised by the Prudential Regulation Authority and regulated by
              the Financial Conduct Authority and the Prudential Regulation
              Authority.
            </p>
            <p>All Rights Reserved.</p>
          </div>
          <div>
            <p>© Copyright 2021 Goldman Sachs Paris Inc. Et Cie</p>
            <p>
              Authorised by the Autorité de Contrôle Prudentiel et de Résolution
              and the Autorité des marchés financiers.
            </p>
            <p>All Rights Reserved.</p>
          </div>
        </div>
        <div className="footer-links-block">
          {footerLinks.map((item, i, items) => {
            return (
              <span key={'footer-' + i} className="footer-link">
                <a href={item.path} target={item.target ? item.target : ''}>
                  {item.item}
                </a>
              </span>
            );
          })}
        </div>
      </div>
    </div>
  );
};

Footer.propTypes = {};
